module.exports = __webpack_public_path__ + "static/water-air-smartspeaker-67d53a3dea954dbca2143bd810e9db89.jpg";